import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a233d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["type", "id", "name", "disabled", "autocomplete", "placeholder"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_dropdown = _resolveComponent("v-dropdown")!

  return (_openBlock(), _createBlock(_component_v_dropdown, {
    triggers: [],
    distance: 12,
    "auto-hide": false,
    shown: !!_ctx.yupErrorsVariable
  }, {
    popper: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["yup-errors text-danger p-8", _ctx.yupErrorsClass])
      }, _toDisplayString(_ctx.yupErrorsVariable), 3)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!!_ctx.prefix)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["input-group-text", _ctx.prefixClass])
            }, _toDisplayString(!!_ctx.prefix.value ? _ctx.$t(_ctx.prefix.value) : ''), 3))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: _ctx.type,
          id: _ctx.id,
          name: _ctx.name,
          class: _normalizeClass({
             [_ctx.inputClass]: true,
              'form-control': !['checkbox', 'radio'].includes(_ctx.type),
              'form-control-sm': _ctx.size === 'sm',
              'is-invalid': !!_ctx.yupErrorsVariable,
            }),
          disabled: _ctx.disabled,
          autocomplete: !!_ctx.autocomplete ? _ctx.autocomplete : null,
          placeholder: !!_ctx.placeholder ? _ctx.$t(_ctx.placeholder) : '',
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tmpVal) = $event)),
          ref: "input",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitUpdateValueEvent && _ctx.emitUpdateValueEvent(...args)), ["enter"]))
        }, null, 42, _hoisted_2), [
          [_vModelDynamic, _ctx.tmpVal]
        ]),
        (!!_ctx.suffix && _ctx.suffix.type === 'text')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["input-group-text", _ctx.suffixClass])
            }, _toDisplayString(!!_ctx.suffix.value ? _ctx.$t(_ctx.suffix.value) : ''), 3))
          : _createCommentVNode("", true),
        (!!_ctx.actionButtons && _ctx.actionButtons.type === 'button' && !_ctx.forceSave)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: _normalizeClass(["btn btn-sm btn-icon btn-success fw-bold p-8 my-8 mx-4", {'opacity-0': !_ctx.isDirty || !!_ctx.yupErrorsVariable}]),
              disabled: !_ctx.isDirty || !!_ctx.yupErrorsVariable,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitUpdateValueEvent && _ctx.emitUpdateValueEvent(...args)))
            }, [
              (!!_ctx.actionButtons.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.actionButtons.value), 1))
                : _createCommentVNode("", true),
              (!!_ctx.actionButtons.icon)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["icon", _ctx.cIconVariant])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3))
          : _createCommentVNode("", true),
        (!!_ctx.actionButtons && _ctx.actionButtons.type === 'button' && !_ctx.forceSave)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass(["btn btn-sm btn-icon btn-danger fw-bold p-8 my-8 mx-4", {'opacity-0': !_ctx.isDirty || !!_ctx.yupErrorsVariable}]),
              disabled: !_ctx.isDirty || !!_ctx.yupErrorsVariable,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetTempValue && _ctx.resetTempValue(...args)))
            }, _hoisted_7, 10, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["shown"]))
}